import labels from "app/labels";
import entityBase from "entityBase";
import * as ko from "knockout";

export class CustomerReports extends entityBase {
  display_view_name: KnockoutObservable<string>;
  display_view_name_label: KnockoutObservable<string>;
  view_name: KnockoutObservable<string>;
  export: KnockoutObservable<boolean>;
  search_criteria: KnockoutObservable<boolean>;

  constructor(item) {
    super();

    this.display_view_name = ko.observable(item.display_view_name);
    if (item.display_view_name) {
      var display_view_name_tmp = "";
      if (item.display_view_name.indexOf("cc_") != -1) {
        display_view_name_tmp =
          item.display_view_name.substring(0, 3) +
          item.display_view_name.substring(3, item.display_view_name.length).toUpperCase();
      } else {
        display_view_name_tmp = item.display_view_name.toUpperCase();
      }
      this.display_view_name_label = ko.observable(labels.descr(display_view_name_tmp));
    } else {
      this.display_view_name_label = ko.observable("");
    }
    this.view_name = ko.observable(item.view_name);
    this.export = ko.observable(item.export == "Y" ? true : false);
    this.search_criteria = ko.observable(item.search_criteria == "Y" ? true : false);
  }
}
